import { getTagManager } from '../api/tagManager';
export const getPersonById = async ({ personId }, logger) => {
    return await getTagManager(`person/${personId}`, {}, logger);
};
